// extracted by mini-css-extract-plugin
export var dot = "ExploreMap-module--dot--fa74c";
export var info = "ExploreMap-module--info--ebdd9";
export var item = "ExploreMap-module--item--ece67";
export var media = "ExploreMap-module--media--6d7d3";
export var plate = "ExploreMap-module--plate--c950a";
export var title = "ExploreMap-module--title--2aa05";
export var type = "ExploreMap-module--type--98998";
export var viewport = "ExploreMap-module--viewport--f4490";